import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import './../styles/layout.css';

const Layout = () => {
  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard';

  return (
    <div className="app-container">
      <Navbar />
      <div className="main-content">
        <Outlet />
      </div>
      {!isDashboard && (
        <footer className="footer">
          <p>&copy; {new Date().getFullYear()} Audio Record News. All rights reserved.</p>
        </footer>
      )}
    </div>
  );
};

export default Layout;
